import React from 'react';
import { theme } from '../../styles/theme';

interface CardProps {
  children: React.ReactNode;
  hover?: boolean;
  glow?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

/** Themed card container with optional hover and glow effects. */
export const Card: React.FC<CardProps> = ({
  children,
  hover = true,
  glow = false,
  style,
  className,
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div
      className={className}
      style={{
        backgroundColor: theme.colors.bgTertiary,
        borderRadius: theme.borderRadius.xl,
        border: `1px solid ${theme.colors.border}`,
        padding: theme.spacing.xl,
        transition: `all ${theme.transitions.base}`,
        transform: hover && isHovered ? 'translateY(-8px)' : 'translateY(0)',
        boxShadow: glow && isHovered ? theme.shadows.glow : theme.shadows.lg,
        ...style,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </div>
  );
};

export default Card;
